import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('[ErrorBoundary] Caught error:', error, info);
    }
  }

  handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={containerStyle}>
          <div style={cardStyle}>
            {/* Icono de error */}
            <div style={iconContainerStyle}>
              <div style={iconStyle}>⚠️</div>
            </div>

            {/* Título */}
            <h2 style={titleStyle}>¡Ups! Algo salió mal</h2>

            {/* Descripción */}
            <p style={descriptionStyle}>
              Ocurrió un error inesperado en la aplicación. No te preocupes, tus datos están seguros.
            </p>

            {/* Botones de acción */}
            <div style={buttonContainerStyle}>
              <button onClick={this.handleReload} style={primaryButtonStyle}>
                🔄 Recargar página
              </button>
              <a href="/" style={secondaryButtonStyle}>
                🏠 Ir al inicio
              </a>
            </div>

            {/* Mensaje de error técnico (solo en desarrollo) */}
            {process.env.NODE_ENV !== 'production' && this.state.error && (
              <details style={detailsStyle}>
                <summary style={summaryStyle}>Detalles técnicos</summary>
                <pre style={errorMessageStyle}>
                  {String(this.state.error?.message || this.state.error)}
                  {this.state.error?.stack && '\n\n' + this.state.error.stack}
                </pre>
              </details>
            )}

            {/* Sugerencia de ayuda */}
            <p style={helpTextStyle}>
              Si el problema persiste, contacta con soporte técnico.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// Estilos
const containerStyle = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  padding: '20px',
  fontFamily: 'system-ui, -apple-system, sans-serif',
};

const cardStyle = {
  background: 'white',
  padding: '40px',
  borderRadius: '16px',
  boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  maxWidth: '600px',
  width: '100%',
  textAlign: 'center',
};

const iconContainerStyle = {
  marginBottom: '20px',
};

const iconStyle = {
  fontSize: '64px',
  animation: 'pulse 2s ease-in-out infinite',
};

const titleStyle = {
  fontSize: '28px',
  fontWeight: '700',
  color: '#333',
  margin: '0 0 16px 0',
};

const descriptionStyle = {
  fontSize: '16px',
  color: '#666',
  lineHeight: '1.6',
  margin: '0 0 30px 0',
};

const buttonContainerStyle = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginBottom: '24px',
};

const buttonBaseStyle = {
  padding: '12px 24px',
  borderRadius: '8px',
  fontSize: '15px',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  border: 'none',
  textDecoration: 'none',
  display: 'inline-block',
};

const primaryButtonStyle = {
  ...buttonBaseStyle,
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
};

const secondaryButtonStyle = {
  ...buttonBaseStyle,
  background: '#f3f4f6',
  color: '#374151',
  border: '2px solid #e5e7eb',
};

const detailsStyle = {
  marginTop: '24px',
  padding: '16px',
  background: '#fef2f2',
  borderRadius: '8px',
  border: '1px solid #fecaca',
  textAlign: 'left',
};

const summaryStyle = {
  cursor: 'pointer',
  fontWeight: '600',
  color: '#991b1b',
  marginBottom: '8px',
};

const errorMessageStyle = {
  fontSize: '12px',
  color: '#b91c1c',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  margin: '8px 0 0 0',
  padding: '12px',
  background: '#fff',
  borderRadius: '4px',
  maxHeight: '200px',
  overflow: 'auto',
};

const helpTextStyle = {
  fontSize: '13px',
  color: '#9ca3af',
  margin: '16px 0 0 0',
};

export default ErrorBoundary;
